import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {ComponentsV1Module, ComponentsV2Module} from '@gatewee/components';
import {ServicesModule} from '@gatewee/services';
import {UtilsModule} from '@gatewee/utils';
import {TranslateModule} from '@ngx-translate/core';
import {TuiAutoColorPipe} from '@taiga-ui/core/pipes/auto-color';
import {TuiInitialsPipe} from '@taiga-ui/core/pipes/initials';
import {TuiDropdown} from '@taiga-ui/core';
import {TuiCalendar} from '@taiga-ui/core/components/calendar';
import {TuiAvatar} from '@taiga-ui/kit';

import {PixAreaComponent} from '../../../elements/pix-area/pix-area.component';
import {BankSlipAreaComponent} from '../../../elements/bank-slip-area/bank-slip-area.component';
import {WithdrawalTransferFormComponent} from './pix/withdrawal-transfer-form.component';
import {WithdrawalEmvFormComponent} from './pix/withdrawal-emv-form.component';
import {QrScannerPaneComponent} from './pix/qr-scanner-pane.component';
import {WithdrawalStepUnlockedComponent} from './pix/steps/withdrawal-step-unlocked.component';
import {WithdrawalStepConfirmedComponent} from './pix/steps/withdrawal-step-confirmed.component';
import {WithdrawalStepValueComponent} from './pix/steps/withdrawal-step-value.component';
import {WithdrawalStepReviewComponent} from './pix/steps/withdrawal-step-review.component';
import {WithdrawalStepPaymentProofComponent} from './pix/steps/withdrawal-step-payment-proof.component';
import {BankSlipPaymentFormComponent} from './bank-slip/bank-slip-payment-form.component';
import {BankSlipStepDigitableComponent} from './bank-slip/steps/bank-slip-step-digitable.component';
import {BankSlipStepReviewComponent} from './bank-slip/steps/bank-slip-step-review.component';
import {BankSlipStepProofComponent} from './bank-slip/steps/bank-slip-step-proof.component';

@NgModule({
  declarations: [
    PixAreaComponent,
    BankSlipAreaComponent,
    WithdrawalTransferFormComponent,
    WithdrawalEmvFormComponent,
    QrScannerPaneComponent,
    WithdrawalStepUnlockedComponent,
    WithdrawalStepConfirmedComponent,
    WithdrawalStepValueComponent,
    WithdrawalStepReviewComponent,
    WithdrawalStepPaymentProofComponent,
    BankSlipPaymentFormComponent,
    BankSlipStepDigitableComponent,
    BankSlipStepReviewComponent,
    BankSlipStepProofComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsV1Module,
    ComponentsV2Module,
    ServicesModule,
    UtilsModule,
    TranslateModule,
    TuiAvatar,
    TuiAutoColorPipe,
    TuiInitialsPipe,
    TuiCalendar,
    ...TuiDropdown,
  ],
  exports: [
    PixAreaComponent,
    BankSlipAreaComponent,
    WithdrawalTransferFormComponent,
    WithdrawalStepUnlockedComponent,
    WithdrawalStepConfirmedComponent,
    WithdrawalStepValueComponent,
    WithdrawalStepReviewComponent,
    WithdrawalStepPaymentProofComponent,
  ],
})
export class WithdrawalPixFormModule {}
